module.exports = __webpack_public_path__ + "img/water.3a40fb56.svg";